const commerceApiUrl = String(
  import.meta.env.VITE_COMMERCE_API_URL || "http://127.0.0.1:8791"
).replace(/\/$/, "");

function storeAuthPath(storeSlug, suffix) {
  return `/v1/storefront/stores/${encodeURIComponent(storeSlug)}/${suffix}`;
}

async function parseResponse(response, fallbackMessage, { requireData = true } = {}) {
  const result = await response.json().catch(() => null);

  if (!response.ok) {
    const error = new Error(fallbackMessage);
    error.status = response.status;
    throw error;
  }

  if (requireData && !result?.data) {
    throw new Error(fallbackMessage);
  }

  return result?.data ?? null;
}

async function requestCustomerAuth(
  url,
  options,
  fallbackMessage,
  parseOptions
) {
  try {
    const response = await fetch(url, options);
    return await parseResponse(response, fallbackMessage, parseOptions);
  } catch (error) {
    if (error?.name === "AbortError" || error?.message === fallbackMessage) {
      throw error;
    }

    throw new Error(fallbackMessage, { cause: error });
  }
}

export async function loginCustomer(
  storeSlug,
  { email, password },
  { signal } = {}
) {
  return requestCustomerAuth(
    `${commerceApiUrl}${storeAuthPath(storeSlug, "customer/login")}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
      signal,
    },
    "Não foi possível entrar na sua conta."
  );
}

export async function fetchCustomerSession(
  storeSlug,
  sessionToken,
  { signal } = {}
) {
  return requestCustomerAuth(
    `${commerceApiUrl}${storeAuthPath(storeSlug, "customer/session")}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${sessionToken}`,
      },
      signal,
    },
    "Não foi possível validar seu acesso."
  );
}

export async function logoutCustomer(
  storeSlug,
  sessionToken,
  { signal } = {}
) {
  return requestCustomerAuth(
    `${commerceApiUrl}${storeAuthPath(storeSlug, "customer/logout")}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${sessionToken}`,
      },
      signal,
    },
    "Não foi possível encerrar sua sessão.",
    { requireData: false }
  );
}
